export const Logo = ({ size = 34, light = false, withText = true, className = "" }) => {
  const line = light ? "#FFFFFF" : "#0F6E56";
  const body = light ? "#E7F3EE" : "#BCE3D6";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <rect x="14.5" y="4" width="11" height="7" rx="2.4" stroke={line} strokeWidth="2.2" />
        <path d="M16 11v3.2L8.6 31.4c-.5 1.2.2 2.4 1.5 2.6 6.6 1.2 13.2 1.2 19.8 0 1.3-.2 2-1.4 1.5-2.6L24 14.2V11" stroke={line} strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M13.6 31.6c0-3.9 2.9-6.6 6.4-6.6s6.4 2.7 6.4 6.6c-4.3.6-8.5.6-12.8 0z" fill={body} />
        <circle cx="20" cy="20.4" r="3.4" fill="#EF9F27" />
      </svg>
      {withText && (
        <span className={`whitespace-nowrap font-display text-[17px] tracking-[-0.02em] ${light ? "text-white" : "text-[#2C2C2A]"}`}>
          Recruiting <span className={light ? "text-[#EF9F27]" : "text-[#0F6E56]"}>Lab</span>
        </span>
      )}
    </span>
  );
};
